<template>
  <div id="voucherTableContent">
    <div
      class="content"
      v-loading="loadings"
      :element-loading-text="loadingTexts"
    >
      <!-- v-loading="loading" :element-loading-text="loadingText" -->
      <div class="mask-table" v-show="isAudits"></div>
      <div class="mask-table" v-show="isCheckOut">
        <img class="setAcount" src="/static/img/setAcount.png" alt="已结账" />
      </div>
      <span class="iconPosition" v-show="btnOpen && isShowNextBtn">
        <!-- <div class="prev" @click="caseVoucher(1)"></div>
        <div class="next" @click="caseVoucher(2)"></div> -->
        <i
          :class="noPerv ? 'el-icon left-n' : 'el-icon left'"
          @click="caseVoucher(1)"
          title="上一张"
        ></i>
        <i
          :class="noNext ? 'el-icon right-n' : 'el-icon right'"
          @click="caseVoucher(2)"
          title="下一张"
        ></i>
      </span>
      <div class="container">

        <div  style="padding-left: 35px">
          <el-row class="header_box">
          <el-col :span="12" style="display:flex;align-items:center;column-gap:30px;">
            <div class="header_label">
              <div>凭证字</div>
              <el-select
                size="mini"
                v-model="voucher.fkVoucherWordId"
                class="elSelect"
                @change="fkVoucherChange"
              >
                <el-option
                  v-for="item in voucherWordList"
                  :key="item.id"
                  :label="item.certificateWord"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-input-number
                v-model="voucher.selfNumber"
                size="mini"
                class="elInput"
                controls-position="right"
                :disabled="insertDisable"
                :min="1"
              ></el-input-number>
              <span class="txt">号</span>
           </div>
           <div  class="header_label">
            <div>日期</div>
            <el-date-picker
              type="date"
              size="mini"
              :clearable="false"
              v-model="voucher.date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions()"
              :editable="false"
              style="width: 202px"
            >
            </el-date-picker>
          </div>
          </el-col>
          <el-col :span="12" style="display:flex;justify-content:flex-end;align-items:center;">
          <!-- 快捷键操作按钮提示 -->
          <div class="tipsKeyCode" v-if="!hideKeyDownTask">
            <i class="keyDownCode" title="快捷键操作" v-popover:popover1></i>
            <el-popover
              ref="popover1"
              trigger="hover"
              title="快捷键规则"
              width="360"
              placement="bottom-end"
            >
              <div class="shortcutKeyTip_popover">
                <h3>保存新增</h3>
                <el-row>
                  <el-col :span="12">Ctrl+S</el-col>
                  <el-col :span="12">保存</el-col>
                  <el-col :span="12">F12</el-col>
                  <el-col :span="12">保存并新增</el-col>
                </el-row>
                <h3>快捷操作</h3>
                <el-row>
                  <el-col :span="12">空格</el-col
                  ><el-col :span="12">借贷金额互换</el-col>
                  <el-col :span="12">=</el-col
                  ><el-col :span="12">自动平衡借贷方金额</el-col>
                  <el-col :span="12">Enter(输入借贷方金额后)</el-col
                  ><el-col :span="12">计算结果且录入第二条分录</el-col>
                  <el-col :span="12">Tab</el-col
                  ><el-col :span="12">光标跳转到下个输入框</el-col>
                  <el-col :span="12">Shift+Tab</el-col
                  ><el-col :span="12">光标跳转到上个输入框</el-col>
                </el-row>
              </div>
            </el-popover>
          </div>
          <div class="header_label" style="z-index:20;">
            <div>附单据</div>
          <!-- <el-form-item label="附单据" class="tipsd" > -->
            <!-- <el-input v-model = "voucher.billNum" size = "small"></el-input> -->
            <div v-if = "isAudits || isCheckOut" class="fixAbove">
              <el-button type = "text" @click = "openDrawerTask" >
                <span class="billNum">{{ voucher.billNum + voucher.numAttach }}</span>
                </el-button>
                张
                <el-button type="text" v-if="(voucher.billNum + voucher.numAttach)>0" @click = "openDrawerTask">查看</el-button>
            </div>
            <template v-else>
              <div class="fixAbove">
                <el-button type = "text" @click = "openDrawerTask" >
                  <span class="billNum">{{ voucher.billNum + voucher.numAttach }}</span>
                  </el-button>
                  张
                <el-button type="text" v-if="(voucher.billNum + voucher.numAttach)>0" @click = "openDrawerTask">查看</el-button>
              </div>
              <!-- <span v-else>
                <span class="billNum">{{ voucher.billNum }}</span>张</span> -->
            </template>
          </div>
          <!-- </el-form-item> -->

          </el-col>
          </el-row>
          <el-row>
             <slot name="showErrorMessage"></slot>
          </el-row>
        </div>
        <voucher-table
         class="voucher-table"
          :kmDate="kmData"
          :superData_fapiao="superData_fapiao"
          :XG_voucherShows="XG_voucherShows"
          :clearAble="clearAbles"
          :exmine="voucher"
          ref="getvoucherTable"
          @on-voucher-change="getVoucherData"
          @clear-success="clearSuccess"
          @on-open-mask="maskVisable"
          @on-voucher-total="getToalNumber"
        ></voucher-table>
      </div>
    </div>
    <div style="text-align: center" v-show="btnDisable && !hideBtn && !isCheckOut" class="btns">
      <div class="pz_btnGroup">
        <el-popover
          placement="top"
          width="170"
          popper-class="templateFile"
          :visible-arrow="false"
          trigger="click">
            <div v-for="(item,index) in templateFiles" :key="index" class="templateItem" :style="{color:item.isCheck?'#269D7B':''}" @click="openPrint(item)">
              <div>{{item.name}} </div><i class="el-icon-success" v-show="item.isCheck"></i>
            </div>
            <el-button
               slot="reference"
              :disabled="loading"
              type="info"
              class="btn1"
            >
            <div class="flexBtn">
              <i class="el-icon-edit upload" style="font-size:16px;margin-right:10px;"></i>
              <div>填写附件模板</div>
            </div>
            </el-button>
        </el-popover>
         <el-button
          :disabled="loading"
          type="info"
          class="btn1"
          @click="uploadFile"
        >
        <div class="flexBtn">
          <i class="btn_icon upload"></i>
          <div>上传凭证附件</div>
        </div>
        </el-button>
        <el-button
          :disabled="loading"
          type="info"
          class="btn1"
          @click="saveTemplate"
          v-show="!superShow && forms"
        >
        <div class="flexBtn">
          <i class="btn_icon temp"></i>
          <div>模板</div>
        </div>
        </el-button>
        <el-button
          :disabled="loading || isCheckOut || isAudits"
          type="success"
          class="btn3 saveBtn"
          @click="saveVoucher()"
        >
          <slot name="saveBtn">
            <div class="flexBtn">
             <i class="btn_icon sava"></i>
            <div>保存</div>
          </div>
          </slot>
        </el-button>
        <el-button
          :disabled="loading || isCheckOut || isAudits"
          type="primary"
          class="btn2"
          @click="saveVoucherAdd('saveAdd')"
          v-show="btnOpen && noNext && !superShow"
        >
            <div class="flexBtn">
             <i class="btn_icon savas"></i>
            <div>保存并新增</div>
            </div>
        </el-button>
        <el-button
          :disabled="loading"
          type="success"
          class="btn3"
          @click="saveVoucherAdd('add')"
          v-show="!noNext &&!hideAdd"
        >
            <div class="flexBtn">
              <i class="btn_icon savas"></i>
            <div>新增</div>
            </div>
        </el-button>
      </div>
    </div>
    <!-- 模板保存 -->
    <el-dialog
      class="default-dialog"
      title="选择模板"
      append-to-body
      :visible.sync="templateModal"
      width="1100px"
      :close-on-click-modal="false"
    >
      <div
        v-loading="temLoading"
        :element-loading-text="temLoadingText"
        class="templates"
      >
        <el-row :gutter="15">
          <el-col :span="6">
            <div class="card-item first">
              <el-card @click.native="openSaveTemplate"> + </el-card>
              <span class="card-text">保存当前凭证为模板</span>
            </div>
          </el-col>
          <el-col :span="6" v-for="(item, index) in selfTems" :key="index">
            <div class="card-item">
              <el-card>
                <p v-for="(item, index) in item.subjectNameList" :key="index">
                  {{ item }}
                </p>
                <div class="maskModal"></div>
                <div class="maskModal1">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="getTemplateChief(item)"
                    >使用</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="delTemplateChief(item)"
                    >删除</el-button
                  >
                </div>
              </el-card>
              <span class="card-text">{{ item.templateName }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" class="minButton" @click="templateModal = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!---->
    <el-dialog
      class="default-dialog"
      title="保存模板为"
      :visible.sync="templateSave"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div v-loading="saveTemLoading" element-loading-text="保存模板中">
        <span
          >将当前正在使用的凭证样式保存到“凭证模板”中，您可以将随时调用这些模板。</span
        >
        <el-form
          style="margin-top: 10px"
          v-if="templateSave"
          ref="templateForm"
          :model="templateForm"
          :rules="temFormRule"
        >
          <el-form-item prop="name">
            <el-input
              v-model="templateForm.name"
              size="small"
              placeholder="模板名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="isSaveMoney">
            <el-checkbox v-model="templateForm.isSaveMoney"
              >同时保存金额</el-checkbox
            >
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="templateSave = false">取消</el-button>
        <el-button
          size="small"
          class="minButton"
          @click="saveTemplateAxios('templateForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 上传凭证附件-->
    <UploadVoucherFile :visible.sync="fileVisible" @sendData="getFileData" ref="uploadFile"/>
    <!-- 附单据详情 -->
    <VoucherDocument :visible = "documentShow" @close = "documentShow = false"  @changeNum="changeNum" @closeAll = "handleCloseAll" :voucher = "voucher"  ref='voucherDocument'/>

    <!-- 附件缩略图列表 -->
    <FileDrawer ref="fileDrawer" :drawerVisible.sync="drawerVisible" :files="fileData" @delFile="delTask" @editTask="editTask" :hideBtn="hideBtn"/>

    <!-- 打印 -->
    <PrintTable ref="printTable" :visible.sync="printTableVisible" :title="printTitle" :type="printType" @saveTemplate="getTemplateInfo" :backShow="backShow"/>
  </div>
</template>

<script>
import PrintTable from '@/components/dialog/printTable.vue'
import FileDrawer from '@/components/drawer/FileDrawer.vue'
import UploadVoucherFile from '@/components/dialog/uploadVoucherFile.vue'
import voucherTable from "@/components/table/voucherTable";
import { mapState, mapMutations } from "vuex";
import VoucherDocument from "@/components/common/voucher-document.vue"
import {editAttachmentInfo} from '@/api'
export default {
  props: [
    'hideKeyDownTask',
    "hideBtn",
    "hideAdd",
    "voucherData",
    "insert",
    "watch",
    "superData_fapiao",
    "XG_voucherShows",
    "openButtonSend",
  ],
  data() {
    return {
      printType:1,
      printTableVisible:false,
      printTitle:"",
      templateFiles:[
        {name:'固定资产折旧表',isCheck:false,value:1},
        {name:"工资表",isCheck:false,value:2},
        {name:"摊销表",isCheck:false,value:3},
        {name:"费用报销表",isCheck:false,value:4},
      ],
      drawerVisible:false,
      fileVisible:false,
      documentShow: false,
      kmData: [],
      total_money: {}, // 总计
      noPerv: false, //不能上一张了
      noNext: true, // 不能下一张了
      maskModal: false,
      isAudits: false,
      isCheckOut: false, // 是否已结账
      insertDisable: false, //插入是 不能修改凭证号
      loading: false,
      clearAbles: false, // 是否清空凭证列表
      loadingText: "保存凭证中",
      loadings: false,
      loadingTexts: "保存凭证中",
      voucherWordList: [],
      voucher: {
        certificateWord: "",
        fkVoucherWordId: "",
        yearPeriods: "",
        date: "",
        title: "",
        year: "",
        periods: "",
        number: 1,
        singlePerson: "",
        auditPerson: "",
        carryOverProfitAndLoss: "",
        billNum: 0, //附单据张数
        numAttach:0,//上传凭证附件数量
        voucherAddendumVoList: [], //凭证列表数据
        id: "",
        isInsert: 0,
        selfNumber: "",
        isCheckOut: 0,
        auditStatus: 0,
      },
      voucherAddendumVoList: [],
      maxNum: "",

      templateModal: false,
      templateData: [],
      temLoading: false,
      temLoadingText: "查询模板中",

      templateSave: false,
      saveTemLoading: false,
      templateForm: {
        isSaveMoney: "",
        name: "",
      },
      temFormRule: {
        name: [{ required: true, message: "模板名称必填！" }],
      },
      selfTems: [],
      fileData:[],
      templateFileData:[],
      fixedAssetsList:[], //固定资产
      taxSalaryList:[], //工资
      amortizationList:[], //摊销
      expenseReimbursementList:[], //费用报销
      backShow:{
        1:[],
        2:[],
        3:[],
        4:[]
      } //回显参数
    };
  },
  components: {
    voucherTable,VoucherDocument,UploadVoucherFile,FileDrawer,PrintTable
  },
  created() {
    const _ = this;
    _.init();
  },
  computed: {
    ...mapState(["sessions", "loadstatus"]),
    //来源于的不展示模板
    forms: {
      get: function () {
        const _ = this;
        if (_.$route.path == "/pageInvoice") {
          return false;
        } else {
          return true;
        }
      },
    },
    btnOpen: {
      get: function () {
        const _ = this;
        if (
          (_.voucherData || _.insert) &&
          !(_.XG_voucherShows && _.openButtonSend)
        ) {
          return false;
        } else {
          return true;
        }
      },
    },
    isShowNextBtn: {
      get: function () {
        return this.voucherData ? this.voucherData.isShowNextBtn : false;
      },
    },
    superShow: {
      get: function () {
        const _ = this;
        if (_.XG_voucherShows && _.openButtonSend) {
          return true;
        } else {
          return false;
        }
      },
    },
    btnDisable: {
      get: function () {
        const _ = this;
        if (_.voucherData && _.watch) {
          return false;
        } else {
          return true;
        }
      },
    },
  },
  methods: {
    getList(oldArr, newArray){
            // 提取新数组 type 集合
      const newTypeSet = new Set(newArray.map(item => item.type));

      // 过滤老数组中不在新 type 集合的元素
      return oldArr.filter(item => !newTypeSet.has(item.type));
    },
    getTemplateInfo(val){
      let fileData = []
      let list = []
      const obj = {
        1:'fixedAssetsList',
        2:'taxSalaryList',
        3:'amortizationList',
        4:'expenseReimbursementList',
      }
      const data = JSON.parse(JSON.stringify(val.data))
      for(let i in val.file){
        fileData.push({
          filePath:val.file[i].imgUrl,
          originalName:val.file[i].fileName,
          thumbnailPath:val.file[i].thumbnailUrl,
          imgUrl:val.file[i].imgUrl,
          fileName:val.file[i].fileName,
          type:this.printType,
          thumbnailUrl:val.file[i].thumbnailUrl,
        })
      }
      this.templateFiles = this.templateFiles.map(item=>{
        if(item.value == this.printType){
          item.isCheck = true
        }
        return item
      })
      for(let i in data){
        data[i].filter(item=>{
          let key = false
          for(let j in item){
            if(item[j]){
              key = true
            }
          }
          if(key){
            console.log(item)
            list.push(item)
          }
        })
      }
      // this.templateFileData = fileData
      this.fileData = this.getList(this.fileData,fileData)
      this.fileData = [...this.fileData,...fileData]
      this.voucher.numAttach = this.fileData.length
      this[obj[this.printType]] = list
      this.backShow[this.printType] = list
      console.log(val,'保存的模版',this.templateFileData,this.fileData)
    },
    openPrint(item){
      this.printTableVisible = true
      this.printTitle = item.name
      this.printType = item.value
    },
    editTask(list){
      this.fileData = JSON.parse(JSON.stringify(list))
      console.log(this.fileData)
    },
    delTask(item,index){
      console.log(item,this.fileData)
      if(item.id){
        const attachmentInfoList = this.fileData.filter(x=>x.imgUrl!=item.imgUrl).map(item=>{
          return {
            originalName:item.fileName,
            thumbnailPath:item.thumbnailUrl,
            filePath:item.imgUrl
          }
        })
        const params ={
          fkVoucherChiefId:item.id,
          attachmentInfoList
        }
        editAttachmentInfo(params).then(res=>{
          if(res.data.code == 1){
            this.$message.success(res.data.msg)
            this.fileData = this.fileData.filter(x=>x.imgUrl!=item.imgUrl)
            this.voucher.numAttach = this.fileData.length
            console.log(this.voucher.numAttach)
            this.voucherData.attachmentInfoList = this.voucherData.attachmentInfoList.filter(x=>x.filePath!=item.imgUrl)
            this.voucher.numAttach = this.voucherData.attachmentInfoList.length
            this.$set(this.voucher,'numAttach',this.voucherData.attachmentInfoList.length),
            console.log(this.voucher.numAttach,this.voucher.billNum)
            // this.$forceUpdate()
            // this.$emit("on-submit-success", true);
          }
        })
        console.log(this.fileData)
        return
      }
      this.fileData = this.fileData.filter(x=>x.imgUrl != item.imgUrl)
      this.voucher.numAttach = this.fileData.length
      this.$refs.uploadFile.editFileList(item)
    },
    openDrawerTask(){
       if(this.fileData.length){
        console.log(11111)
         this.drawerVisible = true
       }
       if(this.voucher.billNum>0){
        const key = this.$refs.voucherDocument.getVoucherBillInfo()
        key.then((res)=>{
          if(res){
              this.documentShow = true
          }
        })

       }
    },
    getFileData(res,fileList,isRemove,file){
      if(isRemove){
        if(this.forms){
          // console.log(this.fileData,file)
          let list = []
          this.fileData.forEach((x,i)=>{
            // console.log(x,file)
            if(file.response){
              if(file.response.data.length>1){
                 this.fileData = this.fileData.filter(k=>{
                  return k.fileName != file.name
                 })
                 this.voucher.numAttach = this.fileData.length
                 console.log(file.response.data)
              }else {
                if(x.imgUrl == file.response.data[0].imgUrl){
                  this.fileData.splice(i,1)
                  this.voucher.numAttach = this.fileData.length
                }
              }
            }
          })
        }else if(fileList.length){
            console.log(2)
            this.fileData.forEach(x=>{

              fileList.forEach(y=>{
                if(y.response){
                  if(x.imgUrl == y.response.data[0].imgUrl){
                    list.push(x)
                  }
                }

              })
          })
          console.log(list)
          this.fileData = list
          this.voucher.numAttach = list.length
        }else {
          this.fileData = []
          this.voucher.numAttach = 0
        }
        console.log(this.fileData)
        return
      }
      if(res.code == 200){
        console.log(this.fileData,res.data)
        this.fileData.push(...res.data)

        //   let list = []
        //       this.fileData.forEach(x=>{
        //       fileList.forEach(y=>{
        //         if(y.response && y.response.data.length){
        //             y.response.data.forEach(k=>{
        //                if(x.imgUrl == k.imgUrl){
        //                   list.push(x)
        //                 }
        //             })

        //         }
        //         if(x.type){
        //           list.push(x)
        //         }
        //       })
        //     })
        //   let zzz = list.reduce((acc, current) => {
        //   if (!acc.some(item => item.id === current.id)) { // 检查是否已存在相同 id
        //     acc.push(current);
        //   }
        //   return acc;
        // }, []);
        //   this.fileData = list
            // console.log(zzz,'res')
          this.voucher.numAttach = this.fileData.length
          // if(this.forms && this.voucherData){
          //   const list = this.voucherData.attachmentInfoList.map(x=>{
          //   return {
          //     thumbnailUrl:x.thumbnailPath,
          //     fileName:x.originalName,
          //     imgUrl:x.filePath,
          //     id:this.voucherData.id
          //   }
          // })
          //   console.log(list,'list')
          //   this.fileData.push(...list)
          //   this.voucher.numAttach = this.fileData.length
          // }
      }
      this.voucher.numAttach = this.fileData.length
    },
    //上传凭证
    uploadFile(){
      this.fileVisible = true
    },
    // 关闭所有弹框
    handleCloseAll() {
      this.documentShow = false;
      this.$emit("close")
    },
    // 附单据改变
    changeNum(num) {
      this.voucher.billNum = num
      this.$emit('refreshTable')
    },
    // 获取金额合计
    getToalNumber(data) {
      if (data) {
        this.total_money = data;
      }
    },
    // 获取子组件清除列表方法
    getvoucherTableResrt() {
      this.$refs.getvoucherTable.resetTable();
      this.clearAbles = true;
      this.voucher.voucherAddendumVoList = [];
    },
    init() {
      const _ = this;
      _.getVoucerWordlList();
    }, //获取凭证列表数据
    getVoucherData(val) {
      const _ = this;

      let data = JSON.parse(JSON.stringify(val));
      for (let i = 0; i < data.length; i++) {
        if (
          data[i].summary == "" &&
          (!data[i].fkSubjectId || data[i].fkSubjectId == "") &&
          data[i].creditorMoney == 0 &&
          data[i].debitMoney == 0
        ) {
          data.splice(i, 1);
          i--;
        }
      }
      _.voucherAddendumVoList = data;
    }, //凭证表初始化数据
    initVouchers() {
      const _ = this;
      if (!_.voucherData) {
        //有传值是 不初始化
        _.initVoucher("");
      }
    },
    initVoucher(id, key) {
      const _ = this;
      _.loading = true;
      _.loadingText = "初始化凭证中";
      _.$http
        .post("voucherChief/initializationVoucher", {
          fkVoucherWordId: id,
        })
        .then((res) => {
          _.loading = false;
          if (res && res.data.code == "1") {
            let datas = res.data.data;
            _.$emit("on-world-change", res.data.data.title);
            _.$store.commit("SAVELOCALVOUCHER", datas);
            datas.date = _.$util.formatDate.format(datas.date, "yyyy-MM-dd");
            _.$setSessionStorage("voucher", res.data.data);
            for (let i in datas) {
              _.$set(_.voucher, i, datas[i]);
            }
            //如果复制中的则赋值拷贝内容
            if (!key) {
              _.getCopyVoucher();
            }
            //_.$resert(_.voucher,datas);
            _.maxNum = res.data.data.number;
            ///当插入凭证时 凭证号
            if (_.insert != "" && _.insert) {
              _.$store.commit("UPDATAVOUCHEREDIT", false); //表示新增凭证中
              _.voucher.selfNumber = _.insert;
              _.insertDisable = true;
              _.voucher.isInsert = 1;
            } else {
              _.insertDisable = false;
              _.voucher.isInsert = 0;
            }
          }
        })
        .catch((e) => {
          _.loading = false;
        });
    }, //切换凭证字
    fkVoucherChange(val) {
      const _ = this;
      if (val != "" && val != null) {
        _.initVoucher(val);
      }
    },
    pickerOptions() {
      let _ = this;
      return {
        disabledDate(date) {
          let d1 = new Date(_.voucher.date);
          let y1 = d1.getFullYear();
          let m1 = d1.getMonth();
          return (
            date.getTime() < new Date(y1, m1, 1) ||
            date.getTime() > new Date(y1, d1.getMonth() + 1, 0)
          );
        },
      };
    },
    getVoucerWordlList() {
      const _ = this;
      _.$http
        .post("voucherWord/getVoucherWordList", {})
        .then((res) => {
          if (res && res.data.code == "1") {
            _.voucherWordList = res.data.data.list;
          }
        })
        .catch((e) => {});
    },
    saveVoucher(key) {
      const _ = this;
      _.loadingText = "保存凭证中";
      let datas = JSON.parse(JSON.stringify(_.voucher));
      let list = JSON.parse(JSON.stringify(_.voucherAddendumVoList));
      datas.attachmentInfoList = this.fileData.map(x=>{
        return {
          originalName:x.fileName,
          thumbnailPath:x.thumbnailUrl,
          filePath:x.imgUrl,
          type:x.type
        }
      })
      datas.attachmentInfoList.push(...this.templateFileData)
      datas.fixedAssetsList = this.fixedAssetsList
      datas.taxSalaryList = this.taxSalaryList
      datas.amortizationList = this.amortizationList
      datas.expenseReimbursementList = this.expenseReimbursementList
      datas.voucherAddendumVoList = list;
      if(this.voucherData){
        datas.fkId = this.voucherData.fkId
        datas.type = this.voucherData.type
      }
      let valid = datas.voucherAddendumVoList;
      if (!/^([1-9]\d*|[0]{1,1})$/.test(datas.billNum)) {
        _.$message.error("附单据只能是零或者大于零的整数!");
        return false;
      }
      for (let i = 0; i < valid.length; i++) {
        delete valid[i].inputFocus;
        delete valid[i].subjectVo.change;
        if (
          valid[i].summary != "" &&
          valid[i].fkSubjectId == "" &&
          valid[i].creditorMoney == 0 &&
          valid[i].debitMoney == 0
        ) {
          //如果只是填写了摘要则删除当前这条 不作提交
          valid.splice(i, 1);
          i--;
          continue;
        }
        if (
          !valid[i].fkSubjectId ||
          valid[i].fkSubjectId == "" ||
          valid[i].fkSubjectId == null
        ) {
          _.$message.error("请选择第" + (i + 1) + "条的科目!");
          return false;
        }
        if (valid[i].summary == "") {
          _.$message.error("请输入第" + (i + 1) + "条的摘要!");
          return false;
        }
        /* if(!/^[\u4E00-\u9FA5A-Za-z\d,.\/@#$%^&*()_+=（）]+$/.test(valid[i].summary)){
					_.$message.error('第'+ (i+1) +'条的摘要不能有特殊字符!');
					return false;
				}; */
        if (
          valid[i].subjectVo.auxiliary != "" &&
          valid[i].subjectVo.auxiliary != null &&
          (valid[i].auxiliaryAccountingIds == "" ||
            valid[i].auxiliaryAccountingIds == undefined)
        ) {
          _.$message.error("请选择第" + (i + 1) + "条的辅助核算!");
          return false;
        }
        if (valid[i].subjectVo.numberAccounting) {
          //数量核算
          // if (valid[i].creditorAmount == 0 && valid[i].debitAmount == 0) {
          //   _.$message.error("请输入第" + (i + 1) + "条的数量!");
          //   return false;
          // }
          if (valid[i].unit == 0) {
            _.$message.error("请输入第" + (i + 1) + "条的单价!");
            return false;
          }
        }
        if (valid[i].subjectVo.foreignCurrency) {
          //外币核算
          if (valid[i].fkForeignCurrencyId == "") {
            _.$message.error("请选择第" + (i + 1) + "条的币种!");
            return false;
          }
          if (valid[i].creditorCoin == 0 && valid[i].debitCoin == 0) {
            _.$message.error("请输入第" + (i + 1) + "条的原币!");
            return false;
          }
          if (valid[i].exchangerate == 0 || valid[i].exchangerate == "") {
            _.$message.error("请输入第" + (i + 1) + "条的汇率!");
            return false;
          }
        }
        if (valid.length < 2) {
          _.$message.error("至少录入两条凭证!");
          return false;
        }
        if (key) {
          delete valid[i].id;
          delete datas.id;
        }
      }
      let isFapiaoData = valid.some((i) => {
        return i.isFapiaoData;
      });
      // console.log("提交数据voucherTableContent，是不是发票", isFapiaoData);
      if (isFapiaoData) {
        this.$emit("on_save_voucher_fp", {
          data: datas,
          total: this.total_money,
        });
      } else {
        for (let i = 0; i < valid.length; i++) {
          if (valid[i].creditorMoney == 0 && valid[i].debitMoney == 0) {
            _.$confirm(
              "第" + (i + 1) + "条的贷方和借方金额都为0,确定提交?",
              "提示",
              {
                confirmButtonText: "继续提交",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false,
              }
            )
              .then(() => {
                _.savesVoucherAxios_public(key, datas);
              })
              .catch(() => {
                return false;
              });
            return false;
          }
        }
        _.savesVoucherAxios_public(key, datas);
      }
    },
    savesVoucherAxios_public(key, datas) {
      /**
			 	70 民间非营利组织
				72 2007年新会计准则科目
				80 小企业会计准则(2013)
				82 行政单位会计制度
			*/
      if (datas.voucherAddendumVoList.length == 2) {
        let accountingSystemCode = JSON.parse(
            sessionStorage.getItem("accountInfo")
          ).accountingSystemCode,
          flag = true,
          taxSubject = datas.voucherAddendumVoList.find((i) => {
            if (accountingSystemCode == "70") {
              return i.subjectVo.name == "其他费用";
            } else {
              return i.subjectVo.name == "所得税费用";
            }
          }),
          _taxSubject = datas.voucherAddendumVoList.find((i) => {
            if (accountingSystemCode == "70") {
              return i.subjectVo.name == "应交税金_应交所得税";
            } else {
              return i.subjectVo.name == "应交税费_应交所得税";
            }
          });
        if (taxSubject || _taxSubject) {
          if (!(taxSubject && _taxSubject)) {
            // 只有一方
            flag = false;
          } else if (!taxSubject.debitMoney && !_taxSubject.creditorMoney) {
            // 都为0
            flag = false;
          } else if (Number(taxSubject.creditorMoney) > 0) {
            // 不在借方
            flag = false;
          }
        }
        if (!flag) {
          this.$confirm("请确认计提所得税分录是否正确，确定提交?", "提示", {
            confirmButtonText: "继续提交",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          }).then(() => {
            this.savesVoucherAxios(key, datas);
          });
        } else {
          this.savesVoucherAxios(key, datas);
        }
      } else {
        this.savesVoucherAxios(key, datas);
      }
    },
    savesVoucherAxios(key, datas) {
      ///提交凭证
      const _ = this;
      _.loadings = true;
      _.$http
        .post("/voucherChief/save", datas)
        .then((res) => {
          _.loadings = false;
          _.$store.commit("UPDATEAUXLIARY", false);
          if (res && res.data.code == "1") {
            this.fixedAssetsList=[]
            this.taxSalaryList=[]
            this.amortizationList=[]
            this.expenseReimbursementList=[]
            this.backShow = {
              1:[],
              2:[],
              3:[],
              4:[]
            }
            this.fileData = []
            this.templateFileData = []
            this.templateFiles = this.templateFiles.map(x=>{
              x.isCheck = false
              return x
            })
            if (key) {
              //如果是保存并新增  则保存数据并清空列表 重新初始化
              _.$store.commit("UPDATAVOUCHEREDIT", false);
              _.clearAbles = true;
              _.voucher.billNum = 0;
              _.voucher.numAttach = 0;
              _.noNext = true;
              _.initVoucher("");
              _.$refs.uploadFile.clearFile();
            } else {
              _.noNext = false;
              _.$store.commit("UPDATAVOUCHEREDIT", true);
              _.handleModify(res.data.data);
              _.$delSessionStorage("copyVoucher"); //删除拷贝的对象
            }
            _.$store.commit("UPDATAVOUCHER", false); //标识还没有修改凭证
            _.$emit("on-submit-success", true);
            _.$message({
              message: "保存成功!",
              type: "success",
            });
            _.$delSessionStorage("copyVoucher"); //删除拷贝的数据
          }
        })
        .catch((e) => {
          _.loadings = false;
        });
    },
    // 列表修改操作
    handleModify(id) {
      const _ = this;
      _.loading = true;
      _.loadingText = "查询凭证详情中";
      _.$http
        .post("voucherChief/getVoucherChief", {
          id: id,
        })
        .then((res) => {
          _.loading = false;
          _.temLoading = false;
          if (res && res.data.code == "1") {
            let list = res.data.data;
            list.date = _.$util.formatDate.format(list.date, "yyyy-MM-dd");
            _.Voucher_Chief_Data = list;
            for (let i in _.voucher) {
              _.$set(_.voucher, i, list[i]);
            }
          }
        })
        .catch((e) => {
          _.loading = false;
        });
    },
    //保存为模板
    saveTemplate() {
      const _ = this;
      _.templateModal = true;
      _.temLoading = true;
      _.temLoadingText = "查询模板中";
      _.$http
        .post("voucherTemplate/opendVoucherTemplateBox", {})
        .then((res) => {
          _.temLoading = false;
          if (res && res.data.code == "1") {
            _.selfTems = res.data.data;
          }
        })
        .catch((e) => {
          _.temLoading = false;
        });
    },
    openSaveTemplate() {
      //保存当前模板为
      const _ = this;
      _.templateForm.isSaveMoney = false;
      _.templateForm.name = "";
      _.templateSave = true;
    }, //保存模板
    saveTemplateAxios(ref) {
      const _ = this;
      _.$refs[ref].validate((valide) => {
        if (valide) {
          let datas = JSON.parse(JSON.stringify(_.voucher));
          datas.isSaveMoney = _.templateForm.isSaveMoney;
          datas.name = _.templateForm.name;
          let list = JSON.parse(JSON.stringify(_.voucherAddendumVoList));
          datas.addendumList = list;
          delete datas.inputFocus;
          _.saveTemLoading = true;
          _.$http
            .post("voucherTemplate/save", datas)
            .then((res) => {
              _.saveTemLoading = false;
              if (res && res.data.code == "1") {
                _.$message({
                  message: "保存模板成功!",
                  type: "success",
                });
                _.templateSave = false;
                _.saveTemplate();
              }
            })
            .catch((e) => {
              _.saveTemLoading = false;
            });
        }
      });
    },
    getTemplateChief(item) {
      //获取模板数据
      const _ = this;
      let datas = JSON.parse(JSON.stringify(_.voucher)).voucherAddendumVoList;
      if (datas.length > 0) {
        _.$confirm("当前凭证已有内容，是否覆盖？", "提示", {
          confirmButtonText: "覆盖",
          cancelButtonText: "取消",
        })
          .then(() => {
            _.diTemplate(item);
          })
          .catch(() => {
            _.templateModal = false;
          });
      } else {
        _.diTemplate(item);
      }
    },
    diTemplate(item) {
      const _ = this;
      _.temLoading = true;
      _.temLoadingText = "使用模板中";
      _.$store.commit("UPDATEAUXLIARY", false);
      //_.$store.commit('UPDATAVOUCHEREDIT',true);  //标识当前为新增凭证
      _.$store.commit("UPDATAVOUCHER", true); //表示凭证已被修改
      _.$http
        .post("voucherTemplate/choiceVoucherAddendumTemplateDate", {
          templateId: item.id,
        })
        .then((res) => {
          _.temLoading = false;
          _.templateModal = false;
          if (res.data.code == "1") {
            _.initVoucher();
            _.voucher.auditStatus = 0;
            _.voucher.isCheckOut = 0;
            _.voucher.voucherAddendumVoList.splice(0);
            let datas = res.data.data.voucherAddendumVoList;
            for (let i = 0; i < datas.length; i++) {
              delete datas[i].id;
              _.voucher.voucherAddendumVoList.push(datas[i]);
            }
            // xiaoli
            this.cloneDeepVoucher();
          }
        })
        .catch((e) => {
          _.temLoading = false;
        });
    },
    delTemplateChief(item) {
      //删除模板
      const _ = this;
      _.$confirm("确定删除 “" + item.templateName + "” 这个模板吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      }).then(() => {
        _.temLoading = true;
        _.temLoadingText = "删除模板中";
        _.$http
          .post("voucherTemplate/deleted", {
            id: item.id,
          })
          .then((res) => {
            _.temLoading = false;
            if (res.data.code == "1") {
              _.saveTemplate();
            }
          })
          .catch((e) => {
            _.temLoading = false;
          });
      });
    },

    //保存并新增
    saveVoucherAdd(key) {
      const _ = this;
      _.loadingText = "保存并新增中";
      if (_.btnOpen) {
        //有按钮功能才能操作
        if (key == "saveAdd") {
          _.saveVoucher(key);
          _.fileData = [];
          _.$refs.uploadFile.clearFile();

        } else if (key == "add") {
          let bol = _.$store.state.loadstatus.ifEditVoucer;
          _.$refs.uploadFile.clearFile();
          _.fileData = [];
          if (bol) {
            _.$confirm("检测到凭证已修改，是否继续当前操作？", "提示", {
              confirmButtonText: "是",
              cancelButtonText: "否",
              closeOnClickModal: false,
            })
              .then(() => {
                _.$store.commit("UPDATAVOUCHER", false);
                _.voucher.auditStatus = 0;
                _.voucher.isCheckOut = 0;
                _.clearAbles = true;
                _.voucher.billNum = 0;
                _.voucher.numAttach = 0;
                _.noNext = true;
                _.initVoucher("");
              })
              .catch(() => {
                _.$store.commit("UPDATAVOUCHER", true);
              });
          } else {
            _.$store.commit("UPDATAVOUCHER", false);
            _.voucher.auditStatus = 0;
            _.voucher.isCheckOut = 0;
            _.voucher.billNum = 0;
            _.voucher.numAttach = 0;
            _.clearAbles = true;
            _.noNext = true;
            _.initVoucher("");
          }
        }
        let valid = _.voucher.voucherAddendumVoList;
        for (let i = 0; i < valid.length; i++) {
          delete valid[i].id;
          delete _.voucher.id;
        }
      }
    },
    caseVoucher(type) {
      const _ = this;
      let bol = _.$store.state.loadstatus.ifEditVoucer;
      _.$store.commit("UPDATAVOUCHER_SUPER", false);
      if (bol) {
        _.$confirm("检测到凭证已修改，是否继续当前操作？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          closeOnClickModal: false,
        })
          .then(() => {
            _.$store.commit("UPDATAVOUCHER", false);
            _.$store.commit("UPDATEAUXLIARY", false);
            if (type == 1) {
              this.UpperVoucher();
            } else if (type == 2) {
              this.LowerVoucher();
            }
          })
          .catch(() => {
            _.$store.commit("UPDATAVOUCHER", true);
          });
      } else {
        _.$store.commit("UPDATEAUXLIARY", false);
        _.$store.commit("UPDATAVOUCHER", false);
        if (type == 1) {
          this.UpperVoucher();
        } else if (type == 2) {
          this.LowerVoucher();
        }
      }
      _.$store.commit("UPDATAVOUCHEREDIT", true);
    },
    //上一张
    UpperVoucher() {
      const _ = this;
      _.noNext = false;
      _.maskModal = false; //取消辅助核算遮罩层
      _.loading = true;
      _.loadingText = "查询上一张";
      _.$http
        .post("voucherChief/replaceUpperVoucher", {
          yearPeriods: _.voucher.yearPeriods,
          number: _.voucher.selfNumber,
        })
        .then((res) => {
          _.loading = false;
          if (res && res.data.code == "1") {
            let list = res.data.data;
            for (let i in list) {
              if (i == "date") {
                _.$set(
                  _.voucher,
                  i,
                  _.$util.formatDate.format(list[i], "yyyy-MM-dd")
                );
              } else {
                _.$set(_.voucher, i, list[i]);
              }
            }
            // xiaoli
            this.cloneDeepVoucher();
            //设置动态的期数时间
            let datas = JSON.parse(JSON.stringify(list));
            delete datas.voucherAddendumVoList;
            _.$store.commit("SAVELOCALVOUCHER", datas);
          } else {
            _.noPerv = true;
          }

          // 传入父组件标记信息
          this.$emit("sendMarkMessage", this.voucher);
        })
        .then((e) => {
          _.loading = false;
        });
    }, //下一张
    LowerVoucher() {
      const _ = this;
      _.noPerv = false;
      _.maskModal = false; //取消辅助核算遮罩层
      _.loading = true;
      _.loadingText = "查询下一张";
      _.$http
        .post("voucherChief/replaceLowerVoucher", {
          yearPeriods: _.voucher.yearPeriods,
          number: _.voucher.selfNumber,
        })
        .then((res) => {
          _.loading = false;
          if (res && res.data.code == "1") {
            let list = res.data.data;
            for (let i in list) {
              if (i == "date") {
                _.$set(
                  _.voucher,
                  i,
                  _.$util.formatDate.format(list[i], "yyyy-MM-dd")
                );
              } else {
                _.$set(_.voucher, i, list[i]);
              }
            }
            // xiaoli
            this.cloneDeepVoucher();
            //设置动态的期数时间
            let datas = JSON.parse(JSON.stringify(list));
            delete datas.voucherAddendumVoList;
            _.$store.commit("SAVELOCALVOUCHER", datas);
          } else {
            _.$store.commit("UPDATAVOUCHEREDIT", false);
            //清空id值
            let valid = _.voucher.voucherAddendumVoList;
            for (let i = 0; i < valid.length; i++) {
              delete valid[i].id;
              delete _.voucher.id;
            }
            _.clearAbles = true;
            _.noNext = true;
            _.voucher.auditStatus = 0;
            _.voucher.isCheckOut = 0;
            _.voucher.singlePerson = "";
            _.initVoucher("");
          }
          // 传入父组件标记信息
          this.$emit("sendMarkMessage", this.voucher);
        })
        .then((e) => {
          _.loading = false;
        });
    },
    // 复制
    getCopyVoucher() {
      const _ = this;
      let tips = _.$route.query.copy;
      if (tips == "1") {
        _.$store.commit("UPDATAVOUCHER_SUPER", false);
        _.$store.commit("UPDATAVOUCHER", true);
        let list = _.$getSessionStorage("copyVoucher");
        delete _.voucher.id;
        _.voucher.voucherAddendumVoList.splice(0);
        if (list && list.voucherAddendumVoList.length > 0) {
          for (let i = 0; i < list.voucherAddendumVoList.length; i++) {
            _.$set(
              _.voucher.voucherAddendumVoList,
              i,
              list.voucherAddendumVoList[i]
            );
          }
          // xiaoli
          this.cloneDeepVoucher();
        }
        _.initVoucher("", "123");
        _.noNext = true;
      }
    },
    clearSuccess(val) {
      const _ = this;
      _.clearAbles = val;
    },
    maskVisable(val) {
      //辅助核算遮罩层
      const _ = this;
      _.maskModal = val;
    },
    // kmData赋值
    cloneDeepVoucher() {
      this.kmData = this.$lodash.cloneDeep(this.voucher.voucherAddendumVoList);
    },
  },
  mounted() {
    const _ = this; //设置快捷键
    _.initVouchers("");
    _.$store.commit("UPDATEAUXLIARY", false);
    //设置快捷键
    // window.onkeydown = function(e){
    // 	let kc = e.keyCode;
    // 	if(e.ctrlKey && e.keyCode == 83){
    // 		_.saveVoucher();
    // 		window.event.returnValue=false;
    // 	}else if(e.keyCode == 123){
    // 		_.saveVoucherAdd('saveAdd');
    // 		window.event.returnValue=false;
    // 	};
    // };
  },
  activated() {
    const _ = this; //设置快捷键
    // _.getVoucerWordlList();
    _.getCopyVoucher();
    _.maskModal = false;
    window.onkeydown = function (e) {
      let kc = e.keyCode;
      if (e.ctrlKey && e.keyCode == 83) {
        _.saveVoucher();
        window.event.returnValue = false;
      } else if (e.keyCode == 123) {
        _.saveVoucherAdd("saveAdd");
        window.event.returnValue = false;
      }
    };

    let bol = _.$store.state.loadstatus.isEditVoucerChange;
    let voucherL = this.voucherAddendumVoList.length;
    if (bol) {
      _.voucher.auditStatus = 0;
      _.voucher.isCheckOut = 0;
      delete _.voucher.id;
      _.clearAbles = true;
      _.initVoucher("");
      _.noNext = true;
    } else {
    }
  },
  deactivated() {
    window.onkeydown = null; ///移出绑定的事件
    //this.$delSessionStorage('copyVoucher'); //删除拷贝的对象
  },
  watch: {
    voucherData: {
      handler(Val) {
        if (Val && Val.voucherAddendumVoList) {
          const _ = this;
          _.$set(_.voucher, "id", Val.id);
          //
          for (let i in _.voucher) {
            if (i != "voucherAddendumVoList") {
              _.$set(_.voucher, i, Val[i]);
            }
          }
          _.voucher.voucherAddendumVoList.splice(0);
          for (let k = 0; k < Val.voucherAddendumVoList.length; k++) {
            _.voucher.voucherAddendumVoList.push(Val.voucherAddendumVoList[k]);
          }
          this.kmData = this.$lodash.cloneDeep(_.voucher.voucherAddendumVoList);
          console.log(Val,'12312')
          this.fixedAssetsList = Val.fixedAssetsList.map(x=>{
            x.startUse =  this.$formart(x.startUse,'yyyy-MM-dd')
            return x
          })
          this.taxSalaryList = Val.taxSalaryList
          this.amortizationList = Val.amortizationList
          this.expenseReimbursementList = Val.expenseReimbursementList.map(x=>{
            x.date = this.$formart(x.date,'yyyy-MM-dd')
            return x
          })
          this.backShow = {
            1:this.fixedAssetsList,
            2:this.taxSalaryList,
            3:this.amortizationList,
            4:this.expenseReimbursementList
          }
          this.templateFiles.forEach(item=>{
              const list = this.backShow[item.value]
              if(list&&list.length){
                item.isCheck = true;
              }
          })
          this.fileData = JSON.parse(JSON.stringify(Val.attachmentInfoList)).map(x=>{
            return {
              thumbnailUrl:x.thumbnailPath,
              fileName:x.originalName,
              imgUrl:x.filePath,
              id:Val.id,
              type:x.type
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
    superData_fapiao: {
      handler(Val) {
        if (!Val) return;
        if (Val && JSON.stringify(Val) === "{}") {
          return;
        }
        const _ = this;
        Val.voucherAddendumVoList = Val.voucherAddendumVoList||Val.preVoucherAddendumList;
        Val.preVoucherAddendumList = Val.preVoucherAddendumList||Val.voucherAddendumVoList
        Val.selfNumber = Val.number;
        Val.billNum = Val.billNum ? Val.billNum : 0;
        Val.numAttach = Val.numAttach?Val.numAttach:0;
        _.$set(_.voucher, "id", Val.id);
        //
        for (let i in _.voucher) {
          if (i != "voucherAddendumVoList") {
            _.$set(_.voucher, i, Val[i]);
          }
        }
        _.voucher.voucherAddendumVoList.splice(0);
        if(Val.voucherAddendumVoList&&Val.voucherAddendumVoList.length){
        for (let k = 0; k < Val.voucherAddendumVoList.length; k++) {
          Val.voucherAddendumVoList[k].isFapiaoData = true;
          _.voucher.voucherAddendumVoList.push(Val.voucherAddendumVoList[k]);
        }
        }
        _.voucher.date = _.$formart(_.voucher.date,'yyyy-MM-dd')
        console.log("初始化发票数据--over");
      },
      immediate: true,
      deep: true,
    },

    voucher: {
      handler(val) {
        //是否结账
        if (val.isCheckOut == 1) {
          this.isCheckOut = true;
        } else {
          this.isCheckOut = false;
        } //是否审核
        if (val.auditStatus == 1) {
          this.isAudits = true;
        } else {
          this.isAudits = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
.templateFile {
  padding: 0 !important;
  .templateItem {
    padding:8px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap:10px;
    color:#666666;
    cursor: pointer;
    font-weight: 400;
    &:hover {
      color:#269D7B;
      font-weight: bold;
      background:rgba(38, 157, 123, 0.1)
    }
  }
}
.handleDialogS {
}
.handler_item {
  h3 {
    line-height: 40px;
    font-weight: bold;
    border-bottom: 1px solid #ebeef5;
  }
  .el-col {
    line-height: 30px;
    color: #666;
  }
}
#voucherTableContent {
  .prev,.next {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  .prev {
    background-size: 100%;
    background-image: url('/static/img/prev.png');
    &:hover {
      background-image: url('/static/img/prev_active.png');
    }
  }
  .next {
    background-size: 100%;
    background-image: url('/static/img/next.png');
    &:hover {
      background-image: url('/static/img/next_active.png');
    }
  }
  .flexBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    // text-align: center;
  }
  .Voucher_OverFLow {
    padding-right: 20px;
  }
  .content {
    width: 1200px !important;
    background: #fff;
    margin: 0 auto;
    border-radius: 5px;
    position: relative;
    .mask-table {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 10;
      img.setAcount {
        width: 130px;
        position: absolute;
        top: 10px;
        right: 200px;
      }
    }
    .container {
      position: relative;
      padding: 20px 50px 20px 20px;
      .voucher-table {
        margin-top: 10px;
      }
      .header_box {
        margin-bottom: 10px;
        .header_label{
          display: flex;
          align-items: center;
          column-gap: 10px;
          .billNum {
            margin-right: 5px;
          }
        }
      }
      .elSelect {
        width: 75px;
      }
      .elInput {
        width: 80px;
        .el-input__inner {
          padding-left: 5px;
          padding-right: 30px;
        }
      }
      .elData {
        margin-left: 20px;
      }
      .el-form-item {
        margin-bottom: 0px !important;
      }
      .el-form.title {
        margin-bottom: 20px;
        text-align: left;
      }
      .tipsKeyCode {
        // float: right;
        font-size: 22px;
        height: 28px;
        // line-height: 50px;
        margin-right: 30px;
        cursor: pointer;
        .keyDownCode {
          display: inline-block;
          width: 35px;
          height: 22px;
          background: url("/static/btn/pingzheng_kuaijiejian.png") no-repeat;
        }
      }
    }
    .iconPosition {
      position: absolute;
      right: 30px;
      // bottom: 10px;
      top: -40px;
      z-index: 99;
      display: flex;
      align-items: center;
      gap: 10px;
      i.el-icon {
        display: inline-block;
        width: 25px;
        height: 25px;
        margin-left: 16px;
        line-height: 25px;
        cursor: pointer;
        &.left {
          background: url("/static/btn/before_n.png") no-repeat center;
        }
        &.left-n {
          background: url("/static/btn/before_d.png") no-repeat center;
        }
        &.right {
          background: url("/static/btn/after_n.png") no-repeat center;
        }
        &.right-n {
          background: url("/static/btn/after_d.png") no-repeat center;
        }
      }
    }
  }
  .pz_btnGroup {
    // display: inline-block;
    margin: 20px auto 0;
    gap:10px;
    padding-bottom: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      min-width: 120px;
      height: 40px;
      line-height: 40px;
      margin:0;
      padding: 0 16px;
    }
    .btn1 {
      color:rgba(38, 157, 123, 1);
      border:0;
      background-color: rgba(38, 157, 123, 0.1);
      &:hover {
        //background-color: #525050;
      }
    }
    .btn2 {
      background-color: #408bff;
      &:hover {
        background-color: #3b7fe8;
      }
    }
    .btn3 {
      background-color: #269d7b;
      &:hover {
        background-color: #1e8467;
      }
    }
    .btn_icon {
      display: inline-block;
      height: 14px;
      width: 14px;
      margin-right: 10px;
      vertical-align: middle;
      &.temp {
        background: url("/static/btn/pingzheng_muban.png") no-repeat;
        background-size: cover;
      }
      &.sava {
        background: url("/static/btn/pingzheng_save.png") no-repeat;
        background-size: cover;
      }
      &.savas {
        background: url("/static/btn/pinzheng_new.png") no-repeat;
        background-size: cover;
      }
      &.upload {
        width: 16px !important;
        height: 16px !important;
        background: url("/static/btn/upload_file.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .tipsd {
    // float: right;
    // margin-right: 0;
    .el-form-item__content {
      width: 75px;
    }
    .el-form-item__label {
      line-height: 40px;
    }
    .el-input {
      width: 56px;
      .el-input__inner {
        padding: 0 5px;
        text-align: center;
      }
    }
    .fixAbove {
      position: absolute;
      z-index: 15;
    }
  }
  .relatives {
    .icons {
      font-size: 16px;
      i {
        height: 25px;
        width: 25px;
        line-height: 25px;
        cursor: pointer;
      }
    }
  }
}
.templates {
  height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
  .card-item {
    .el-card {
      height: 150px;
      cursor: pointer;
      position: relative;
      .el-card__body {
        height: 110px;
      }
      .maskModal {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #333;
        opacity: 0.4;
        z-index: 0;
      }
      .maskModal1 {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 100%;
        z-index: 1;
        align-items: center;
        justify-content: center;
      }
      &:hover {
        .maskModal1 {
          display: flex;
        }
        .maskModal {
          display: block;
        }
      }
    }
    .card-text {
      font-size: 14px;
      line-height: 30px;
      display: block;
      text-align: center;
    }
    &.first {
      .el-card {
        text-align: center;
        font-size: 60px;
        line-height: 90px;
        background-color: #f2f2f2;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/voucherTableContent.vue